import * as maxLength from "ApiMaxLength";
import { HookFormInput } from "components/HookForm/HookFormInput";
import { ResourceKeys, useAddBoard } from "providers";
import React from "react";

export const AddBoardForm: React.FC = () => {
  const { form } = useAddBoard();
  const { control } = form;

  return (
    <>
      <HookFormInput
        name="shortName"
        control={control}
        label={ResourceKeys.Board_ShortName}
        contextHelp={ResourceKeys.Board_ShortName_Help}
        maxLength={maxLength.boardShortName}
      />

      <HookFormInput
        name="longName"
        control={control}
        label={ResourceKeys.Board_LongName}
        contextHelp={ResourceKeys.Board_LongName_Help}
        maxLength={maxLength.boardLongName}
      />

      <HookFormInput
        name="name"
        control={control}
        label={ResourceKeys.Board_Name}
        required
        maxLength={maxLength.boardName}
        contextHelp={ResourceKeys.Board_Name_Help}
      />
    </>
  );
};
